import RosterIdentityLinkedIdentityContactInfo from './RosterIdentityLinkedIdentityContactInfo';

export default RosterIdentityLinkedIdentityContactInfo;
